<template>
    <AthModal @close="onClose">
        <template #content>
            <AthModalStandard :uiTitle="titleLbl" :uiIsGlobal="false" @close="onClose" class="br-m">
                <template #body>
                    <FormInput class="el--s-m sm-b-l"
                        v-for="(field, index) in fields"
                        :key="index"
                        :placeholder="field.placeholder"
                        :lbl="field.label"
                        v-model="formValues[field.name]"
                        :uiAutoFocus="index === 0" />
                </template>
                <template #footer>
                    <AthButton class="el--s-m el--t-primary"
                        :disabled="!isFormValid"
                        @click="onSubmit"
                        :lbl="submitLbl" />
                </template>
            </AthModalStandard>
        </template>
    </AthModal>
</template>

<script>
import AthModalStandard from '../modal-styles/Standard.vue';
import FormInput from '../../atoms/forms/FormInput.vue';
import AthButton from '../../atoms/Button.vue';
import AthModal from './Modal.vue';

export default {
    name: 'mead-standalone-form-modal',
    props: {
        /**
         * Title text (i18n key) displayed in the modal's header.
         */
        titleLbl: {
            type: String,
            default: 'Form'
        },
        /**
         * The list of form fields to render, each requiring at least a `name` and `label`; also
         * used to build and validate the internal formValues object.
         */
        fields: {
            type: Array,
            required: true,
            validator: (fields) => fields.every(f => f.name && f.label)
        },
        /**
         * Initial values keyed by field name, used to prefill formValues when the form is
         * (re)initialized.
         */
        initialValues: {
            type: Object,
            default: () => ({})
        },
        /**
         * Label text for the submit button.
         */
        submitLbl: {
            type: String,
            default: 'Submit'
        }
    },
    components: {AthModal, AthModalStandard, FormInput, AthButton},
    data() {
        return {
            formValues: {}
        };
    },
    computed: {
        isFormValid() {
            return this.fields.every(field => {
                const value = this.formValues[field.name];
                return !field.required || (value && value.trim() !== '');
            });
        }
    },
    created() {
        this.initializeForm();
    },
    methods: {
        initializeForm() {
            this.formValues = this.fields.reduce((acc, field) => {
                acc[field.name] = this.initialValues[field.name] || '';
                return acc;
            }, {});
        },
        onSubmit() {
            this.$emit('submit', { ...this.formValues });
        },
        onClose: function () {
            this.$emit('close');
        },
    },
    watch: {
        initialValues: {
            handler() {
                this.initializeForm();
            },
            deep: true
        }
    }
};
</script>